export default "__VITE_ASSET__Dcg1POOq__"